import React from "react";
import { useSelector } from "react-redux";
import CountrySelector from "../CountrySelector";
import { useTranslation } from "../../contexts/LanguageContext";

export default function Bids() {
  const { bids, loading } = useSelector((state) => state.dashboard);
  const { t } = useTranslation();

  // Calculate max bid value for percentage calculation
  const maxBidValue = bids.length > 0 
    ? Math.max(...bids.map(b => b.totalBids || b.bidsCount || 1), 1) 
    : 1;

  return (
    <div className="bg-white px-4 py-4 border border-gray-100 shadow-md rounded-lg">
      {/* Header Area */}
      <div className="flex items-center justify-between">
        <h3 className="font-medium font-base">{t("dashboard.bidsPlaced")}</h3>
        <CountrySelector />
      </div>

      <div className="mt-6">
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          </div>
        ) : bids.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500 text-sm">{t("dashboard.noBidsAvailable")}</p>
          </div>
        ) : (
          <div>
            <dt className="space-y-6">
              {bids.slice(0, 7).map((bid, index) => {
                const bidCount = bid.totalBids || bid.bidsCount || 0;
                const percentage = Math.max((bidCount / maxBidValue) * 100, bidCount > 0 ? 10 : 0);
                return (
                  <dd key={bid._id || index} className="flex items-center">
                    <div className="w-36 text-xs font-semibold truncate" title={bid.auctionTitle || bid.title || `Auction ${index + 1}`}>
                      {bid.auctionTitle || bid.title || `Auction ${index + 1}`}
                    </div>
                    <div className="w-full bg-gray-100 rounded">
                      <div
                        className="bg-primaryBlue text-xs font-medium text-white text-center p-0.5 py-1 leading-none rounded-sm transition-all duration-300"
                        style={{ width: `${percentage}%` }}
                      >
                        {bidCount}
                      </div>
                    </div>
                  </dd>
                );
              })}
            </dt>
          </div>
        )}
      </div>
    </div>
  );
}
